import React from 'react';
import { AdditionalOptionsFirstComment } from './includes/FirstComment';
import { AdditionalOptionsDisableComments } from './includes/DisableComments';
import { TIKTOK_BUSINESS_PAGE } from '../../../../config/constants';
import { CreatorVerticalSeparator } from '../include/VerticalSeperator';

export const TikTokAdditionalOptions: React.FC<any> = ({
  platform = TIKTOK_BUSINESS_PAGE
}) => {
  return (
    <div className="border border-secondary px-2 py-2 rounded">
      <AdditionalOptionsFirstComment platform={platform} />
      <CreatorVerticalSeparator />
      <AdditionalOptionsDisableComments platform={platform} />
    </div>
  );
};
